import {useCallback} from 'react';
import {CropperAspect, ImageDropzone, ImageValue, ImageWithCrop} from '@legit.health/ui';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import {Box, Typography} from '@mui/material';
import useImageMaxFileSize from '@/shared/hooks/useImageMaxFileSize';

export default function ImageField({
  onChange,
  value,
  name,
  placeholderImage,
  sizeErrorMessage,
  generalErrorMessage,
  typeErrorMessage,
  dataTestId,
  label
}: {
  value: ImageValue;
  onChange: (value: ImageWithCrop | null) => void;
  name: string;
  placeholderImage: string;
  label: string;
  sizeErrorMessage: string;
  generalErrorMessage: string;
  typeErrorMessage: string;
  dataTestId?: string;
}) {
  const customMaxFileSize = useImageMaxFileSize();

  const handleSelectImage = useCallback(
    function (imageWithCrop: ImageWithCrop | null) {
      onChange(imageWithCrop);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div>
      <Box
        sx={{
          mt: {
            xs: 2,
            lg: 0
          }
        }}
      >
        <ImageDropzone
          containerSx={{
            borderColor: 'primary.main',
            borderRadius: 1,
            p: {
              xs: 2,
              lg: 0
            }
          }}
          onChange={handleSelectImage}
          withCropper
          cropperAspect={CropperAspect.FREE}
          {...(customMaxFileSize && {maxFileSize: customMaxFileSize})}
          sizeErrorMessage={sizeErrorMessage}
          generalErrorMessage={generalErrorMessage}
          typeErrorMessage={typeErrorMessage}
          placeholder={
            <Box
              sx={{
                position: 'relative',
                '& img': {
                  display: 'block',
                  width: '100%',
                  height: 'auto'
                }
              }}
            >
              <AddAPhotoIcon
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: 'auto',
                  color: 'primary.main',
                  fontSize: '4rem'
                }}
              />

              <img src={placeholderImage} alt={name} />
              <Typography
                sx={{
                  mt: 1,
                  color: 'primary',
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  textAlign: 'center'
                }}
              >
                {label}
              </Typography>
            </Box>
          }
          value={value}
          dataTestId={dataTestId}
        />
      </Box>
    </div>
  );
}
